<!--
 * @Description: 关于我们页面组件
 -->
<template>
  <div class="about" id="about" name="about">
    <div class="about-header">
      <div class="about-title">
        <i class="el-icon-tickets" style="color: #ff6700;"></i>
        关于我们
      </div>
    </div>
    <div class="about-content">
      <div class="brand-intro">
        <div class="brand-header">
          <img src="../assets/logo.png" alt="频遇" class="brand-logo" />
          <h1 class="brand-title">频遇俱乐部 PINYU CLUB</h1>
        </div>
        <div class="brand-description">
          <p>频遇俱乐部（PINYU CLUB）是一家专注于提供优质商品和服务的电商平台。</p>
          <p>我们致力于为用户打造便捷、愉悦的购物体验，精选各类优质商品，包括手机、家电、配件等多种品类。</p>
          <p>频遇俱乐部秉承"品质至上、服务第一"的经营理念，为每一位用户提供优质的商品和贴心的服务。</p>
        </div>
        <div class="brand-info">
          <h3>联系我们</h3>
          <p><i class="el-icon-office-building"></i> 公司名称：频遇俱乐部有限公司</p>
          <p><i class="el-icon-location"></i> 地址：浙江省杭州市</p>
          <p><i class="el-icon-phone"></i> 客服热线：400-XXX-XXXX</p>
          <p><i class="el-icon-message"></i> 邮箱：service@pinyu.com</p>
          <p class="icp-info">浙ICP备2026016956号</p>
        </div>
      </div>
      <MyMarkdown></MyMarkdown>
    </div>
  </div>
</template>
<script>
import MyMarkdown from "../components/MyMarkdown";
export default {
  components: {
    MyMarkdown
  }
};
</script>
<style scoped>
.about {
  background-color: #f5f5f5;
}
.about .about-header {
  height: 64px;
  background-color: #fff;
  border-bottom: 2px solid #ff6700;
}
.about .about-header .about-title {
  width: 1225px;
  margin: 0 auto;
  height: 64px;
  line-height: 64px;
  font-size: 28px;
}
.about .content {
  padding: 20px 0;
  width: 1225px;
  margin: 0 auto;
}
.about .content .goods-list {
  margin-left: -13.7px;
  overflow: hidden;
}
.about .about-content {
  width: 1225px;
  margin: 0 auto;
  background-color: #fff;
  padding: 30px;
  box-sizing: border-box;
}

.about .brand-intro {
  padding: 20px 0;
}

.about .brand-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}

.about .brand-header .brand-logo {
  height: 60px;
  width: auto;
  margin-right: 15px;
}

.about .brand-header .brand-title {
  font-size: 28px;
  color: #333;
  margin: 0;
}

.about .brand-description {
  text-align: center;
  margin-bottom: 40px;
  padding: 0 50px;
}

.about .brand-description p {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  margin: 10px 0;
}

.about .brand-info {
  border-top: 1px solid #eee;
  padding-top: 30px;
  text-align: center;
}

.about .brand-info h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
}

.about .brand-info p {
  font-size: 14px;
  color: #666;
  margin: 10px 0;
}

.about .brand-info p i {
  color: #ff6700;
  margin-right: 8px;
}

.about .brand-info .icp-info {
  margin-top: 30px;
  color: #999;
  font-size: 12px;
}
</style>
